import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'total', 'error', 'submitButton'];
  static values = {
    allSubsidiariesCompleted: Boolean,
    fileUploaded: Boolean,
  };

  connect() {
    this.element.addEventListener('file-field:changed', this.handleFileChange);
    this.updateTotal();
  }

  validateInput() {
    this.updateTotal();
    this.validateSubmit();
  }

  updateTotal() {
    const total = this.getWeightTotal();

    this.totalTarget.textContent = `${total.toFixed(2)} %`;

    if (total !== 100) {
      this.errorTarget.hidden = false;
      this.submitButtonTarget.disabled = true;
    } else {
      this.submitButtonTarget.disabled = false;
      this.errorTarget.hidden = true;
    }

    this.validateSubmit();
  }

  getWeightTotal() {
    let total = 0;

    this.inputTargets.forEach((input) => {
      const val = parseFloat(input.value);
      if (!isNaN(val)) total += val;
    });

    return total;
  }

  isWeightValid() {
    return this.getWeightTotal() === 100;
  }

  handleFileChange = () => {
    this.fileUploadedValue = true;
    this.validateSubmit();
  };

  validateSubmit() {
    if (this.isWeightValid() && this.allSubsidiariesCompletedValue && this.fileUploadedValue) {
      this.submitButtonTarget.classList.remove('disable');
    } else {
      this.submitButtonTarget.classList.add('disable');
    }
  }

  disconnect() {
    this.element.removeEventListener('file-field:changed', this.handleFileChange);
  }
}
